import { useContext } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import OfferList from 'components/OfferList/OfferList'

import ContactContext from 'contexts/contactContext'
import { CRUISE_UNIFIED_FILTERS } from 'constants/cruise'

import BodyText from 'LuxKit/Typography/BodyText'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import TextLink from 'LuxKit/TextLink'
import TextButton from 'LuxKit/Button/TextButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'

function CruiseOfferListNoResults() {
  const intl = useIntl()
  const currentContact = useContext(ContactContext)
  const localContact = currentContact.local

  return <Group direction="vertical" gap={32}>
    <Group direction="vertical" gap={8}>
      <Heading variant="heading2">
        {intl.formatMessage({
          id: 'AbkMJ7uYZ_u_jnIyc1fO',
          defaultMessage: 'Sorry, we couldn’t find any cruises',
          description: 'Heading shown when no cruise search results are found',
        })}
      </Heading>
      <BodyText variant="large">
        <FormattedMessage
          id="WHYadevvq2Q7kdinnSno"
          defaultMessage="Didn’t find what you were looking for? <tabletBreakpoint>Speak to one of our travel experts <phoneLink>{phoneNumber}</phoneLink></tabletBreakpoint>"
          description="Message shown when no cruise search results are found, with contact information"
          values={{
            tabletBreakpoint: (chunks) => (
              <CSSBreakpoint min="tablet" as="span">
                {chunks}
              </CSSBreakpoint>
            ),
            phoneLink: (chunks) => (
              <TextLink href={`tel:${localContact.number}`} rel="nofollow">
                {chunks}
              </TextLink>
            ),
            phoneNumber: localContact.humanReadable,
          }}
        />
      </BodyText>
      <CSSBreakpoint only="mobile">
        <TextButton
          startIcon={<LinePhoneIcon />}
          fit="mobile-full-width"
          kind="secondary"
          href={`tel:${localContact.number}`}
          rel="nofollow"
        >
          {intl.formatMessage({
            id: '-aTT9f8ov0WIsvLw7LLI',
            defaultMessage: 'Speak to a travel expert',
            description: 'Button text to call travel expert when no cruise results found',
          })}
        </TextButton>
      </CSSBreakpoint>
    </Group>
    <Group direction="vertical" gap={16}>
      <Heading variant="heading2">
        <FormattedMessage
          id="aTd393I2iSQje0LUMfxn"
          defaultMessage="Our top <exclusive>exclusive</exclusive> offers"
          description="Section heading for top exclusive cruise offers section"
          values={{
            exclusive: (chunks) => <i>{chunks}</i>,
          }}
        />
      </Heading>
      <OfferList filters={CRUISE_UNIFIED_FILTERS} tileStyle="search" />
    </Group>
  </Group>
}

export default CruiseOfferListNoResults
